var alphaSortedTerms = function alphaSortedTerms(terms) {
  return terms.sort(function (a, b) {
    return a.label.localeCompare(b.label);
  });
};

export default alphaSortedTerms;